<ul class="no-list-style font-body-1 medium-type">
  @for (item of items(); track item) {
    @if (item.withDivider) {
      <li class="ps-xsmall-y divider"><hr /></li>
    }
    <li>
      @if (item.link) {
        <a
          (beforeNavigation)="handleClick(item.id, $event)"
          class="flex no-underline nordic-blue-900-text ps-medium-x ps-small-y"
          [class.current-item]="item.active"
          [finLink]="item.link"
          [external]="item.external"
          [attr.target]="item.openInNewTab ? '_blank' : ''"
          [attr.data-testid]="item.attrs?.['data-testid']"
        >
          <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ item }" />
        </a>
      } @else {
        <button
          class="fill align-left ps-medium-x ps-small-y"
          [attr.data-testid]="item.attrs?.['data-testid']"
          (click)="handleClick(item.id, $event)"
        >
          <ng-container [ngTemplateOutlet]="itemContent" [ngTemplateOutletContext]="{ item }" />
        </button>
      }
    </li>
  }
</ul>

<ng-template #itemContent let-item="item">
  @if (item.icon?.position === IconPosition.LEFT) {
    <fcom-icon class="icon-medium ms-xsmall-r" [name]="item.icon.name" [category]="item.icon.category" />
  }
  {{ item.teaserTitle }}
  @if (item.icon?.position === IconPosition.RIGHT) {
    <fcom-icon class="icon-medium ms-xsmall-l" [name]="item.icon.name" [category]="item.icon.category" />
  }
  @if (!item.icon && item.external) {
    <fcom-icon class="icon-medium ms-xsmall-l" [name]="SvgLibraryIcon.EXTERNAL_TAB" />
  }
</ng-template>
